import React, { useCallback, useEffect, useState } from 'react';

import styled from 'styled-components';

import api from '../../services/api';

import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import Input from '../Form/Input';
import MessageErrorValidator from '../MessageErrorValidator';

import { BtnToggle, ButtonRemove, CheckListWrapper, Container, Footer, Form, MainScrollContainer, NotTasks, Task, TodoItemWrapper } from './styles';
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import { CheckCircle, ClipboardText, Confetti, Smiley, Trash, Warning } from 'phosphor-react';
interface ITodoListProps {
  id: string;
  description: string;
  background: string;
  is_completed: boolean;
}

type ITasksTypes = 'all' | 'completed' | 'notCompleted';

const statusTaskType = {
  'all': 'Nenhuma tarefa encontrada. Crie uma nova tarefa agora mesmo no campo acima!',
  'completed': 'Ops! Nenhuma tarefa concluída encontrada.',
  'notCompleted': 'Ops! Nenhuma tarefa ativa encontrada.',
}

interface InputTodoListProps {
  task: ITodoListProps;
  handleCompletedTask: (task: ITodoListProps) => void;
  handleRemoveFromTodo: (index: number, id: string) => void;
  index: number;
}

const InputTodoList: React.FC<InputTodoListProps> = ({ task, handleCompletedTask, handleRemoveFromTodo, index }) => {
  return (
    <TodoItemWrapper>
      <aside>
        <input defaultChecked={task.is_completed} defaultValue={task.id} name="r" type="checkbox" id={task.id} onChange={() => handleCompletedTask(task)} />
        <label htmlFor={task.id}>
          {task.description}
        </label>
      </aside>
      <footer>
        {task.is_completed && (
          <ButtonRemove onClick={() => handleRemoveFromTodo(index, task.id)}>
            <Trash size={18} weight="duotone" /></ButtonRemove>
        )}
      </footer>
    </TodoItemWrapper>
  );
};

const TodoListModule: React.FC = () => {

  // Validation
  const schema = Joi.object({
    description: Joi.string().min(5).max(100).required().messages({
      '*': 'Informe uma tarefa válida.',
      'string.min': `O campo descrição deve ter no mínimo {#limit} caracteres`,
      'string.max': `O campo descrição deve ter no máximo {#limit} caracteres`,
    }),
  });

  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
    resolver: async (data, context, options) => {
      console.log('formData', data);
      console.log('validation result', await joiResolver(schema)(data, context, options));
      return joiResolver(schema)(data, context, options);
    },
  });

  const [todoList, setTodoList] = useState<ITodoListProps[]>([]);
  const [filter, setFilter] = useState<ITasksTypes>('all');

  const filteredTodoList = todoList.filter((item) => {
    if (filter === 'completed') {
      return item.is_completed;
    }
    if (filter === 'notCompleted') {
      return !item.is_completed;
    }

    return true;
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get(`/tasks`);
        console.log(response.data);
        setTodoList(response.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleRemoveFromTodo = useCallback(async (index: number, id: string) => {
    try {
      await api.delete(`/tasks/${id}`);
      setTodoList(todoList.filter((_, i) => i !== index));

      toast.success('Tarefa removida com sucesso!', {
        duration: 5000,
        position: 'bottom-right',
      });

      setFilter('all');
    } catch (error) {
      console.log(error);
      toast.error('Erro ao remover tarefa');
    }
  }, [todoList]);

  const handleCompletedTask = useCallback(async (task: ITodoListProps) => {
    try {
      await api.patch(`/tasks/${task.id}`);
      const newTodoList = todoList.map((item) => {
        if (item.id === task.id) {
          item.is_completed = !item.is_completed;
        }
        return item;
      });
      setTodoList(newTodoList);
    } catch (error) {
      console.log(error);
      toast.error('Erro ao completar tarefa');
    }
  }, [todoList]);

  const onSubmit = handleSubmit(async (data) => {
    try {
      console.log(data);

      const response = await api.post(`/tasks`, {
        description: capitalizeFirstLetter(data.description),
      });

      if (response.status === 200) {
        setFilter('all');
        console.log(response.data);
        setTodoList([response.data, ...todoList]);

        reset({
          description: '',
        });

        const focus = document.querySelector('#description') as HTMLInputElement;
        focus.focus();

      }
    } catch (error: any) {
      console.log('error:::::::: ', error.response.data);
    }
  });

  const handleSetFilter = useCallback((filter: ITasksTypes) => {
    setFilter(filter);
  }, []);

  return (
    <StyledWrapper>
      <Form onSubmit={onSubmit}>
        <aside>
          <Input register={register} id="description" name="description" type="text" label="Descreva sua tarefa" autoComplete="off" placeholder="Criar nova tarefa..." />
          {errors?.description?.message && <MessageErrorValidator>{errors?.description?.message as string}</MessageErrorValidator>}
        </aside>
        <main>
          <button type="submit">Adicionar tarefa</button>
        </main>
      </Form>
      <CheckListWrapper style={filteredTodoList.length > 0 ? { overflowY: 'scroll', padding: '1.5rem 0.25rem 6rem 1.5rem' } : {  overflowY: 'scroll', padding: '1.5rem 0.25rem 6rem 1.5rem' }}>
        {filteredTodoList.length > 0 ?
          filteredTodoList.map((task, index) => (
            <InputTodoList
              key={task.id}
              task={task}
              handleCompletedTask={handleCompletedTask}
              index={index}
              handleRemoveFromTodo={() => handleRemoveFromTodo(index, task.id)}
            />
          ))
          :
          <NotTasks>
            <header>
              <div>
                <Warning size={40} weight='duotone' />
              </div>
              <h5>Nenhuma tarefa encontrada</h5>
            </header>
            <main>
              <p>{`${statusTaskType[filter]}`}</p>
            </main>
          </NotTasks>
        }
      </CheckListWrapper>
      <Footer>
        <div>
          <div>
            <BtnToggle badgeValue={todoList.length} className={filter === 'all' ? 'current' : ''} onClick={() => handleSetFilter('all')}><ClipboardText size={28} weight="duotone" /> Todas</BtnToggle>
          </div>
          <div style={{ justifyContent: 'center' }}>
            <BtnToggle badgeValue={todoList.filter((task) => !task.is_completed).length} className={filter === 'notCompleted' ? 'current' : ''} onClick={() => handleSetFilter('notCompleted')}><CheckCircle size={28} weight="duotone" /> Ativas</BtnToggle>
          </div>
          <div>
            <BtnToggle badgeValue={todoList.filter((task) => task.is_completed).length} className={filter === 'completed' ? 'current last' : 'last'} onClick={() => handleSetFilter('completed')}><Smiley  size={28} weight="duotone" /> Concluídas</BtnToggle>
          </div>
        </div>
      </Footer>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 0;
  border-radius: 0 0 ${({ theme }) => theme.radius.primary} ${({ theme }) => theme.radius.primary};
`;


export default TodoListModule;